import {
  SleepEntity,
} from './sleepEntity';
import { MeasureDateTime } from './valueObjects/measureDateTime';
import { MeasurerId } from './valueObjects/measurerId';
import { MeasurerType } from './valueObjects/measurerType';
import { ParentId } from './valueObjects/parentId';

import type {
  SleepPropsPub,
  SleepPropsPvt,
} from './sleepEntity';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';
import type { SleepJson, SleepJsonPub, SleepJsonPvt } from '@/types/domain/sleep/entities/sleepEntity';

import { FactoryPub } from '@/domain/factoryPub';

/**
 * 睡眠ファクトリ
 */
export class SleepFactory extends FactoryPub<
  SleepEntity,
  SleepPropsPvt,
  SleepJsonPvt,
  SleepPropsPub,
  SleepJsonPub
> {
  /**
   * 比較する
   * @param a 対象1
   * @param b 対象2
   * @returns 差分
   */
  comparePub = (
    a: SleepJson,
    b: SleepJson,
  ) => {
    const da = new Date(a.data.measureDateTime);
    const db = new Date(b.data.measureDateTime);
    return da < db ? 1 : -1;
  };

  /**
   * Entityを生成する
   * @param props プロパティプライベート
   * @param propsPub プロパティ公開
   * @returns Entity
   */
  create(
    props: SleepPropsPvt,
    propsPub: EntityPubNotNullType<SleepPropsPub>,
  ): SleepEntity {
    return new SleepEntity(props, propsPub);
  }

  /**
   * データからEntityを作成
   * @param props データ
   * @returns Entity
   */
  createFromEntityDataPub(
    props: EntityDataPubNotNullType<SleepJsonPvt, SleepJsonPub>,
  ): SleepEntity {
    return this.create({
      isSleepTime: props.data.isSleepTime,
      measurerId: MeasurerId.create(props.data.measurerId),
      measurerType: MeasurerType.create(props.data.measurerType),
      measureDateTime: MeasureDateTime.create(new Date(props.data.measureDateTime)),
      parentId: ParentId.create(props.data.parentId),
      childId: ParentId.create(props.data.childId),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {},
    });
  }
}
